import {createAction} from '@reduxjs/toolkit'

import {PageViewEventType, PageViewValueType} from './constants'

/** 공통 action 으로 분리 필요 */
export const pageViewAction = createAction<{
    /** page view target */
    target: PageViewEventType
    /** 옵션으로 전달할 값 */
    value?: PageViewValueType
}>('pageViewAction')
